import React, { CSSProperties } from "react";
import styles from "./markdown-support-popover.module.scss";
import { useI18N } from "@src/language/language-context";

const cssClassName = "mark-down-popover";

interface MarkdownSupportPopoverProps {
  customTopPositioning?: number;
}

export const MarkdownSupportPopover = ({
  customTopPositioning = 25,
}: MarkdownSupportPopoverProps) => {
  const i18n = useI18N();
  const texts = {
    supportMarkDownFormatting: i18n(
      "modules.markdownSupportPopover.supportMarkDownFormatting",
    ),
    regularList: i18n("modules.markdownSupportPopover.regularList"),
    item: i18n("modules.markdownSupportPopover.item"),
    subItem: i18n("modules.markdownSupportPopover.subItem"),
    orderedList: i18n("modules.markdownSupportPopover.orderedList"),
    first: i18n("modules.markdownSupportPopover.first"),
    second: i18n("modules.markdownSupportPopover.second"),
  };
  return (
    <div
      className={styles[cssClassName]}
      style={
        {
          "--popover-top": `${customTopPositioning}px`,
        } as CSSProperties
      }
    >
      <div className={styles[`${cssClassName}__container`]}>
        <p className={styles[`${cssClassName}__title`]}>
          {texts.supportMarkDownFormatting}
        </p>

        <div className={styles[`${cssClassName}__content`]}>
          {/* Regular List */}
          <div className={styles[`${cssClassName}__column`]}>
            <p className={styles[`${cssClassName}__heading`]}>
              {texts.regularList}
            </p>

            <p className={styles[`${cssClassName}__item`]}>
              <span className={styles[`${cssClassName}__marker`]}>-</span>{" "}
              {texts.item}
            </p>

            <p
              className={`${styles[`${cssClassName}__item`]} ${
                styles[`${cssClassName}__sub-item`]
              }`}
            >
              <span className={styles[`${cssClassName}__marker`]}>-</span>{" "}
              {texts.subItem}
            </p>
          </div>

          {/* Ordered List */}
          <div className={styles[`${cssClassName}__column`]}>
            <p className={styles[`${cssClassName}__heading`]}>
              {texts.orderedList}
            </p>

            <p className={styles[`${cssClassName}__item`]}>
              <span className={styles[`${cssClassName}__marker`]}>1.</span>{" "}
              {texts.first}
            </p>

            <p className={styles[`${cssClassName}__item`]}>
              <span className={styles[`${cssClassName}__marker`]}>2.</span>{" "}
              {texts.second}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
